import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (userData) => api.post('/auth/register', userData),
  changePassword: (passwordData) => api.post('/auth/change-password', passwordData),
  createAdmin: (adminData) => api.post('/auth/create-admin', adminData),
};

export const upgradeRequestAPI = {
  create: (requestData) => api.post('/upgrade-requests', requestData),
  getAll: (params) => api.get('/upgrade-requests', { params }),
  getById: (id) => api.get(`/upgrade-requests/${id}`),
  update: (id, data) => api.put(`/upgrade-requests/${id}`, data),
  delete: (id, reason) => api.delete(`/upgrade-requests/${id}`, { 
    data: reason ? { reason } : undefined 
  }),
  getAcceptanceDocument: (id) => api.get(`/upgrade-requests/${id}/acceptance-document`),
  getDeleted: (params) => api.get('/upgrade-requests/deleted', { params }),
  restore: (id) => api.post(`/upgrade-requests/${id}/restore`),
};

export const adminAPI = {
  getDashboardStats: () => api.get('/admin/dashboard-stats'),
  getUsers: (params) => api.get('/admin/users', { params }),
  getUserById: (id) => api.get(`/admin/users/${id}`),
  createUser: (userData) => api.post('/admin/users', userData),
  updateUser: (id, userData) => api.put(`/admin/users/${id}`, userData),
  deleteUser: (id) => api.delete(`/admin/users/${id}`),
  resetUserPassword: (id, passwordData) => api.post(`/admin/users/${id}/reset-password`, passwordData),
  exportReports: (params) => api.get('/admin/reports/export', { params }),
};

export const packageAPI = {
  getAll: (params) => api.get('/packages', { params }),
  getById: (id) => api.get(`/packages/${id}`),
  create: (packageData) => api.post('/packages', packageData),
  update: (id, packageData) => api.put(`/packages/${id}`, packageData),
  delete: (id) => api.delete(`/packages/${id}`),
  getUpgradeOptions: (currentBandwidth) => api.get(`/packages/upgrade-options/${currentBandwidth}`),
};

export const importAPI = {
  importMitra: (formData) => api.post('/import/mitra', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  importPackages: (formData) => api.post('/import/packages', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  downloadMitraTemplate: (format = 'csv') => api.get(`/import/templates/mitra?format=${format}`, {
    responseType: 'blob',
  }),
  downloadPackageTemplate: (format = 'csv') => api.get(`/import/templates/packages?format=${format}`, {
    responseType: 'blob',
  }),
};

export default api;